import React from "react";
import "./styles.css";
const Header: React.FunctionComponent = () => {
  return (
    <header className="header">
      <h2>Totally Original Idea!</h2>
    </header>
  );
};

export default Header;
